<template>
  <div class="fly-box reverse-ssh-setup-instructions">
    <div class="fly-box divider" />
    <div class="fly-text fly-text--ui-medium value-title">
      Setup Instructions
    </div>
    <div class="fly-box setup-fields">
      <FlyInput
        class="fly-input fly-input--column"
        label="Path to Private Key"
        placeholder="~/.ssh/id_ed25519"
        :value="privateKeyPath"
        @input="privateKeyPath = $event.target ? $event.target.value : $event"
      />
    </div>
    <div class="fly-box setup-steps">
      <div class="fly-text fly-text--ui-small step">
        <strong>1.</strong> Install autossh on your server (or a server that has
        access to your database):
      </div>
      <FlyCodeBlock lang="bash" :text="`sudo apt-get install autossh`" />
      <div class="fly-text fly-text--ui-small step">
        <strong>2.</strong> Add Integrate.io's server to your known_hosts:
      </div>
      <FlyCodeBlock lang="bash" :text="knownHostsCommand" />
      <div class="fly-text fly-text--ui-small step">
        <strong>3.</strong> Test the connection:
      </div>
      <FlyCodeBlock lang="bash" :text="testConnectionCommand" />
      <div class="fly-text fly-text--ui-small step">
        <strong>4.</strong> Run autossh for a persistent connection:
      </div>
      <FlyCodeBlock lang="bash" :text="autosshCommand" />
      <div class="fly-text fly-text--ui-small step">
        <strong>5.</strong> Add to crontab for automatic reconnect on reboot
        (<code>crontab -e</code>):
      </div>
      <FlyCodeBlock lang="bash" :text="crontabCommand" />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import FlyCodeBlock from 'shared/components/Text/FlyCodeBlock.vue';
import FlyInput from 'shared/components/Form/FlyInput.vue';

export default {
  name: 'ReverseSSHSetupInstructions',
  components: {
    FlyCodeBlock,
    FlyInput,
  },
  props: {
    tunnelEndpoint: VueTypes.string.isRequired,
    dbHost: VueTypes.string.def(''),
    dbPort: VueTypes.oneOfType([String, Number]).def(''),
  },
  data() {
    return {
      privateKeyPath: '',
      // Must match REVERSE_SSH_PORT and REVERSE_SSH_USER in tunnel_interactor.py
      reverseSSHDaemonPort: 50683,
      reverseSSHUser: 'sshtunnel',
    };
  },
  computed: {
    reverseSSHHost() {
      const idx = this.tunnelEndpoint.lastIndexOf(':');
      return this.tunnelEndpoint.substring(0, idx);
    },
    reverseSSHPort() {
      const idx = this.tunnelEndpoint.lastIndexOf(':');
      return this.tunnelEndpoint.substring(idx + 1);
    },
    dbTarget() {
      const host = this.dbHost || '<your-db-host>';
      const port = this.dbPort || '<your-db-port>';
      return `${host}:${port}`;
    },
    knownHostsCommand() {
      return `ssh-keyscan -p ${this.reverseSSHDaemonPort} ${this.reverseSSHHost} >> ~/.ssh/known_hosts`;
    },
    keyPath() {
      return this.privateKeyPath || '<path-to-private-key>';
    },
    testConnectionCommand() {
      return `ssh -NR ${this.reverseSSHPort}:${this.dbTarget} ${this.reverseSSHUser}@${this.reverseSSHHost} -i ${this.keyPath} -p ${this.reverseSSHDaemonPort} -o "ExitOnForwardFailure yes" -o ServerAliveInterval=10 -o ServerAliveCountMax=1 -v`;
    },
    autosshCommand() {
      return `autossh -M 0 -f -N -R ${this.reverseSSHPort}:${this.dbTarget} ${this.reverseSSHUser}@${this.reverseSSHHost} -i ${this.keyPath} -p ${this.reverseSSHDaemonPort} -o "ExitOnForwardFailure yes" -o ServerAliveInterval=10 -o ServerAliveCountMax=1`;
    },
    crontabCommand() {
      return `@reboot autossh -M 0 -f -N -R ${this.reverseSSHPort}:${this.dbTarget} ${this.reverseSSHUser}@${this.reverseSSHHost} -i ${this.keyPath} -p ${this.reverseSSHDaemonPort} -o "ExitOnForwardFailure yes" -o ServerAliveInterval=10 -o ServerAliveCountMax=1`;
    },
  },
};
</script>

<style lang="scss">
.reverse-ssh-setup-instructions {
  flex-direction: column;
  width: 100%;

  .value-title {
    font-weight: 500;
    margin-bottom: 8px;
  }

  .divider {
    margin: 12px 0;
  }

  .setup-fields {
    flex-direction: column;
    width: 100%;
    margin-bottom: 4px;
  }

  .setup-steps {
    flex-direction: column;
    width: 100%;

    .step {
      margin: 8px 0 4px 0;
    }
  }
}
</style>
